import * as trace from 'owa-trace';
import { getGuid } from 'owa-guid';
import { Mini3SScenario } from '../schema/SubstrateScenarios';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import { SubstrateSignalType } from 'mini-3s-telemetry/lib/schema/SubstrateSignalType';
import { SubstrateTelemetryEvent } from 'mini-3s-telemetry/lib/schema/SubstrateTelemetryEvent';

const TRACE_ID_RESPONSE_HEADER = 'request-id';
const HTTP_STATUS_ON_ERROR = 408;

export function with3SResponseReceivedSignal<T>(
    requestName: string,
    substrateService: (clientRequestId: string) => Promise<Response>,
    logicalId: string,
    scenario: Mini3SScenario
): Promise<T> {
    const clientRequestId = getGuid();

    signalWorkflowEvent(
        SubstrateTelemetryEvent.ResponseReceived,
        { workFlowId: clientRequestId },
        { signalType: SubstrateSignalType.WorkFlowStart }
    );

    return substrateService(clientRequestId)
        .then(response =>
            response.json().then(resp => ({
                parsedResponse: resp,
                httpStatus: response.status,
                traceId: response.headers.get(TRACE_ID_RESPONSE_HEADER),
            }))
        ) // httpResponse stream should be converted to JSON object
        .then((response: { parsedResponse: T; httpStatus: number; traceId: string }) => {
            const { parsedResponse, httpStatus, traceId } = response;
            signalWorkflowEvent(
                SubstrateTelemetryEvent.ResponseReceived,
                {
                    workFlowId: clientRequestId,
                    logicalId,
                    traceId,
                    status: httpStatus,
                    scenario,
                },
                { signalType: SubstrateSignalType.WorkFlowEnd }
            );
            return parsedResponse;
        })
        .catch(error => {
            signalWorkflowEvent(
                SubstrateTelemetryEvent.ResponseReceived,
                {
                    workFlowId: clientRequestId,
                    logicalId,
                    traceId: clientRequestId,
                    status: HTTP_STATUS_ON_ERROR,
                    scenario: scenario,
                },
                { signalType: SubstrateSignalType.WorkFlowEnd }
            );
            trace.errorThatWillCauseAlert(
                `${requestName}: Unable to fetch/parse results ${error.message}`
            );
            return null;
        });
}
